module.exports = __webpack_public_path__ + "static/media/Any-Decision.a988807c.jpg";